<div style="margin: 2px; border: 1px solid grey; width: 500px; height: 395px; float: left; position: relative;">
  <div style="background: white; cursor: pointer; width: 100%; height: 20px;"><span *ngIf="video">{{video.name}}</span></div>
  <object id="videoPlugin{{index}}" align="center" classid="clsid:8C1A66F8-F28E-43fb-AF78-11D3163E6635" codebase="" style="width: 500px; height: 375px;">
    <PARAM NAME="activextype" VALUE="0">
    <PARAM NAME="wndtype" VALUE="0">
    <PARAM NAME="needborder" VALUE="0">
    <PARAM NAME="colors" VALUE="0">
  </object>
</div>
